// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-fit[data-v-75a4731f]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
module.exports = exports;
